<template  >
     <div class="text-center">



    <v-dialog
      v-model="dialog"
      width="500"
    >



      <template v-slot:activator="{on: dialog}">
      <v-tooltip bottom
      :nudge-top="tooltip.nudgeTop"
      :nudge-right="tooltip.nudgeRight"
      :open-on-focus="focus"

      >
        <template v-slot:activator="{on:tooltip}">
            <div v-on="tooltip">

        <v-btn
              :color="color||undefined"
              icon
              :x-small="size.xSmall || false"
              :small="size.small || false"
              :disabled="disabled||false"

              v-on="{...tooltip, ...dialog}"


            >
            <v-icon>mdi-delete</v-icon>
        </v-btn>
            </div>
        </template>
        <span>{{disabled? `Only owners can delete`: 'Delete'}}</span>

        </v-tooltip>
      </template>


      <v-card>


        <v-card-text>

         Are you sure you want to permanently delete this {{name}}?
        </v-card-text>



        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleteAtRoute(route, id)"
          >
            Yes
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialog =false"
          >
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import {deleteAtRoute, get, set} from '@/utils/utils.js'
import { mapState } from 'vuex'

export default {
    name: 'DeleteButton',
    props: ['route','id', 'name', 'color', 'size', 'disabled'],
    data () {
      return {
        dialog: false,
        xSmall: true,
        focus: false
      }
    },
    computed: {
        ...mapState({
            tooltip: 'tooltip',
            collectionScope: 'collectionScope',
            locationScope: 'locationScope'
        })
    },
    methods: {
        deleteFromFrontend(route,id){

            if(route ==='collection'){



                this.$store.dispatch('updateState',
                        ['myCollections',this.$store.state.myCollections.filter(x => x.id!=id) ])
                    //this covers case where we're viewing the collection we just deleted
                    //(you don't need this for locations because there's no separate /loc_id route there)
                    this.$store.dispatch('updateState', ['collection', {}])

            }
            else if(route ==='custom_location_group'){


                this.$store.dispatch('updateState',
                        ['myLocationGroups',this.$store.state.myLocationGroups.filter(x => x.id!=id) ])
            }


        },
        deleteAtRoute(route, id){
            //close popup
            this.dialog=false;

            //delete from database
            deleteAtRoute(route,id).then(
                res => {
                    this.deleteFromFrontend(route,id)

                    if(route==='collection'){

                        //remove just deleted collection from generation check
                         let colsToGenerate = get('colsToGenerate')||[]
                        set('colsToGenerate',colsToGenerate.filter(x=>x!==id))




                    }
         else if(route ==='custom_location_group'){

            let locationsToCheck = get('locationsToCheck')||[]
            let group = locationsToCheck.find(x=>x.id===id);
            if(group){
                locationsToCheck = locationsToCheck.filter(x=>x.id!=id)
                set('locationsToCheck', locationsToCheck)
            }

        }


        })



        }

    }
}
</script>

<style scoped>
.v-card__text{
    padding-top: 20px !important;
    padding-bottom: 0 !important;
    font-size:16px;
}
</style>
